@if (showEmptyCart()) {
  <div
    class="cart-items cart-items--empty"
    [style.color]="settings.emptyCartTextColor || null"
    [innerHTML]="settings.emptyCartText"></div>
} @else {
  <div class="cart-items">
    <div class="cart-items__list">
      <div class="cart-items__row">
        <div
          class="cart-items__image"
          [style.width.px]="imageWidth"
          [style.height.px]="imageHeight"
          [style.background-color]="imageBackground">
          @if (sample.image) {
            <img [src]="sample.image" [alt]="sample.title" />
          }
        </div>

        <div class="cart-items__content" [style.justify-content]="contentJustify">
          <div class="cart-items__title-row">
            <p class="cart-items__title" [title]="sample.title">{{ sample.title }}</p>
            <div class="cart-items__prices">
              <span class="cart-items__price">{{ formattedPrice }}</span>
              @if (hasDiscount) {
                <span class="cart-items__price-original">{{ formattedOriginalPrice }}</span>
              }
            </div>
          </div>

          @if (settings.changeVariant) {
            <div class="cart-items__variants">
              @for (opt of sample.variantOptions; track opt.name) {
                <div class="cart-items__variant">
                  <span class="cart-items__variant-label">{{ opt.name }}: {{ opt.selected }}</span>
                  <span class="cart-items__variant-chevron" aria-hidden="true">▾</span>
                  <select disabled class="cart-items__variant-select">
                    @for (v of opt.values; track v) {
                      <option [selected]="v === opt.selected">{{ v }}</option>
                    }
                  </select>
                </div>
              }
            </div>
          }

          <div class="cart-items__qty-row">
            @if (settings.quantityInput.inputType === 'dropdown') {
              <select disabled class="cart-items__qty-select">
                @for (n of qtyRange; track n) {
                  <option [selected]="n === sample.quantity">{{ n }}</option>
                }
              </select>
            } @else {
              <div class="cart-items__qty-stepper">
                <button type="button" disabled class="cart-items__qty-btn">−</button>
                <input type="number" [value]="sample.quantity" disabled class="cart-items__qty-input" />
                <button type="button" disabled class="cart-items__qty-btn">+</button>
              </div>
            }

            <button type="button" disabled class="cart-items__remove">REMOVE</button>
          </div>

          @if (settings.subscription.enabled) {
            @if (settings.subscription.selectorType === 'upgrade_button') {
              <button
                type="button"
                class="cart-items__sub-btn"
                [style.color]="resolvedSubscription.textColor"
                [style.background-color]="resolvedSubscription.backgroundColor"
                [style.border-radius.px]="resolvedSubscription.cornerRadius"
                (mouseenter)="onSubHoverEnter($event)"
                (mouseleave)="onSubHoverLeave($event)">
                {{ subscriptionLabel }}
              </button>
            } @else {
              <div
                class="cart-items__sub-dropdown"
                [style.background-color]="resolvedSubscription.backgroundColor"
                [style.border-radius.px]="resolvedSubscription.cornerRadius"
                (mouseenter)="onSubHoverEnter($event)"
                (mouseleave)="onSubHoverLeave($event)">
                <select disabled class="cart-items__sub-select" [style.color]="resolvedSubscription.textColor">
                  <option>One-time purchase</option>
                  <option selected>Subscribe weekly — {{ sample.samplePlanDiscount }}% off</option>
                </select>
                <span class="cart-items__sub-chevron" [style.color]="resolvedSubscription.iconColor" aria-hidden="true"
                  >▼</span
                >
              </div>
            }
          }
        </div>
      </div>
    </div>
  </div>
}
